import React, { useState, useEffect } from 'react'
import jQuery from 'jquery';
import { Link } from 'react-router-dom';
import Play from './Page/Play';
import Wallet from './Page/Wallet';
// import chat from '../assets/img/sodapdf-converted.gif'
import Whatsapp from '../assets/img/whatsappicon.png'
import axios from "axios";
import { useNavigate } from 'react-router-dom';


export default function Footer() {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate()

  const handleReload = () => {
    // loaduser2();
    window.scrollTo(0, 0);
  };
  useEffect(() => {

    loaduser1();
    // loaduser2();

  }, [])
  const loaduser1 = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      const url = `${process.env.REACT_APP_API_URL}/POM_get_user_profile`;


      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id
      };


      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });


      const objectRes = response.data;
      setUserData(objectRes);

      console.warn(objectRes);

    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  jQuery(function () {
    jQuery('.menu .iconmenu').click(function () {
      jQuery('.iconmenu').removeClass("activemenu");
      jQuery(this).addClass("activemenu");


    });
    jQuery(window).scroll(function () {
      if (jQuery(this).scrollTop() > 50) {
        jQuery('.footer-menu').addClass('footerscroll');
      } else {
        jQuery('.footer-menu').removeClass('footerscroll');
      }
    });
  });


  const loaduser2 = async () => {
    const user_id = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");

    let url = (`${process.env.REACT_APP_API_URL}/POM_get_user_profile.php`);

    const formData = new FormData();
    formData.append('app_id', process.env.REACT_APP_API_ID);
    formData.append('user_id', user_id);
    formData.append('dev_id', dev_id);
    var config = {
      method: 'POST',
      url: url,
      body: formData,
    };
    axios.post(url, formData, config)
      .then(function (response) {
        const res = JSON.stringify(response.data);
        const refcode = response.data.refCode;

        const objectRes = JSON.parse(res);
        const login_token = localStorage.getItem('login_token');

        setUserData(objectRes);
        console.warn(objectRes.login_token);
        if (objectRes.login_token != login_token) {
          localStorage.clear();
          navigate('/login');
        }
      })
  }

  return (

    <>

      <a href='https://api.whatsapp.com/send?phone=9358178480'>
        {/* <div className="chaticon">
        <img src={Whatsapp}/>
   </div> */}

      </a>
      <div className="footer-menu">
        <div className="menufooter">
          {/* {userData && userData.is_playstore == 0 ? */}
          <ul>
            <></>
            <li className="menu ">
              <div className='iconmenu activemenu'>
                <Link to="/" onClick={handleReload} className='buttonpage' >
                  <i class="bi bi-house-door-fill"></i>
                  <span>Home</span>
                </Link>
              </div>
            </li>
            <li className="menu">
              <div className='iconmenu'>
                <Link to="/Play" onClick={handleReload} className='buttonpage'>
                  <i class="bi bi-controller"></i>
                  <span> Play</span></Link>
              </div>
            </li>
            <li className="menu">
              <div className='iconmenu'>
                <Link to="/wallet" onClick={handleReload} className='buttonpage'>
                  <i class="bi bi-wallet2"></i>
                  <span>Wallet</span></Link>
              </div>
            </li>

            <li className="menu">
              <div className='iconmenu'>
                <Link to="/History" className='buttonpage'>
                  <i class="bi bi-joystick"></i>
                  <span>My Game </span></Link>
              </div>
            </li>
          </ul>

        </div>
      </div>
    </>
  )
}
